import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class LeaveReward extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            manager_of_user: [],
            leaves: [],
            rewards: [],
            employee: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userEmail: has_local_data ? localdata.user_email : '',
            leave_reward_state: 1,
            startDate: new Date(),
            endDate: new Date(),
            fromdate: '',
            todate: '',
            fields: {},
            errors: {},
            registered_mail: '',
            first_half_checked: 0,
            second_half_checked: 0,
            search: '',
            order_by: 'desc',
            order_column: 'created_date',
            off_count: 0,
            item_count: 0,
            owners: [],
            user: [],
        };
        this.handleChangeStart = this.handleChangeStart.bind(this);
        this.handleChangeEnd = this.handleChangeEnd.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onHalfDayFirstChange = this.onHalfDayFirstChange.bind(this);
        this.onHalfDaySecondChange = this.onHalfDaySecondChange.bind(this);
        this.searchChange = this.searchChange.bind(this);
    }
    // ER#63778: Leave Application for Manger/HR Admin 
    searchChange(event) {
        this.setState({ search: event.target.value, activePage: 1 }, function () {
            this.leaveRewardBalance();
        });
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    onHalfDayFirstChange() {
        var day_first = document.getElementById('half_day_first');
        if (day_first.checked === true) {
            this.setState({ first_half_checked: 1, })
        }
        else {
            this.setState({ first_half_checked: 0, })
        }
    }

    onHalfDaySecondChange() {
        var day_first = document.getElementById('half_day_second');
        if (day_first.checked === true) {
            this.setState({ second_half_checked: 1, })
        }
        else {
            this.setState({ second_half_checked: 0, })
        }
    }

    handleChangeStart(date) {
        this.setState({
            startDate: date,
            start_date: moment(date).format("YYYY-MM-DD")
        });
    }

    handleChangeEnd(date) {
        this.setState({
            endDate: date,
            end_date: moment(date).format("YYYY-MM-DD")
        });
    }

    onChange(event) {
        let fields = this.state.fields;
        this.setState({ [event.target.name]: event.target.value });
        fields[event.target.name] = event.target.value;
    }

    showLeave() {
        fetch(this.state.apiUrl + '/HrmanagementRest/showLeave/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    leaves: findresponse.leaves
                })
            })
    }

    showReward() {
        fetch(this.state.apiUrl + '/HrmanagementRest/showReward/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    rewards: findresponse.rewards
                })
            })
    }

    leaveRewardBalance(page = 1) {
        fetch(this.state.apiUrl + '/HrmanagementRest/leaveRewardBalance/page/' + page + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    leavesAvailable: findresponse.leaves_available,
                    leavestaken: findresponse.leaves_taken,
                    leave_earned: findresponse.total_leaves,
                    carry_forward_leave_earned: findresponse.carry_forward_leave_earned,
                    lop_cnt: findresponse.lop_cnt,
                    advance_leave_cnt: findresponse.advance_leave_cnt,
                    rewardsPoints: findresponse.rewards_points,
                    manager_of_user: findresponse.manager_of_user,
                    attachment: findresponse.attachment,
                    attachment_url: findresponse.attachment_url,
                    emp_start_name: findresponse.emp_start_name,
                    view_access: findresponse.view_access,
                    item_count: findresponse.item_count,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes',
                    name: findresponse.name,
                    position: findresponse.position,
                    hr_permission: findresponse.hr_permission,
                    current_quarter: findresponse.current_quarter,
                })
            })
    }

    approve_leave(id) {
        const fd = new FormData;
        fd.append('inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/HrmanagementRest/approveLeave/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                window.location.href = '/leaveReward';
            })
    }

    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        console.log(this.state.fields);
        if (!fields["decline_note"]) {
            formIsValid = false;
            errors["decline_note"] = "This field is required.";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    decline_leave(id) {
        // if (this.handleValidation()) {
        //     console.log("Data Has been submitted");
        // } else {
        //     console.log("This Fields Are required.")
        //     return false;
        // }
        const fd = new FormData;
        fd.append('inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/HrmanagementRest/declineLeave/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                window.location.href = '/leaveReward';
            })
    }

    changeStateLeaveReward() {
        window.$('#leave-search').hide();
        { this.setState({ leave_reward_state: 0 }) }
    }

    changeStateRewardLeave() {
        window.$('#leave-search').hide();
        { this.setState({ leave_reward_state: 1 }) }
    }

    changeStateLeaveApp() {
        window.$('#leave-search').show();
        { this.setState({ leave_reward_state: 2 }) }
    }

    employee_details() {
        fetch(this.state.apiUrl + '/HrmanagementRest/ViewEmployeeLeaveReward/id/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.decrypt(responseJson, 1);
                this.setState({
                    employee: responseJson.employee
                })
            })
    }

    leave_detail(id) {
        fetch(this.state.apiUrl + '/HrmanagementRest/LeaveDetails/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    leave_detail: findresponse.leave_detail,
                })
                this.setState({ startDate: moment(Date.parse(this.state.leave_detail.date)) })
                this.setState({ endDate: moment(Date.parse(this.state.leave_detail.to_date)) })
            })
    }

    apply_leave() {
        const fd = new FormData;
        fd.append('inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/HrmanagementRest/ApplyLeave/id/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.code == 200) {
                    window.location.href = '/leaveReward/';
                }
                else if (findresponse.code == 500) {
                    this.setState({ registered_mail: findresponse.msg }, function () {
                    });
                }
                else if (findresponse.code == 700) {
                    this.setState({ registered_mail: findresponse.msg }, function () {
                    });
                }
                else if (findresponse.code == 900) {
                    this.setState({ registered_mail: findresponse.msg }, function () {
                    });
                }
                else if (findresponse.code == 1100) {
                    this.setState({ registered_mail: findresponse.msg }, function () {
                    });
                }
            })
    }

    getRangeCheck() {
        var st_date = moment(this.state.startDate).format("YYYY-MM-DD")
        var en_date = moment(this.state.endDate).format("YYYY-MM-DD")
        if (st_date == en_date) {
            return ''
        }
        else {
            return (
                <p class="feature-check mar_top_20 margin_bottom_less">
                    <input type="checkbox" id="half_day_second" name="half_day_second" class="half_day_second" value onChange={this.onHalfDaySecondChange} />
                    <label for="half_day_second"><span></span>Half Day</label>
                </p>
            )
        }
    }

    componentDidMount() {
        document.title = "Intranet | Leave Rewards";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.showLeave();
        this.showReward();
        this.leaveRewardBalance();
    }

    // ER#63778 Leave application start
    SortCloumn(column) {
        var dynaic_id = 'col_' + column;
        var order_by, arrow;
        if (this.state.order_by == 'desc') {
            order_by = 'asc'
            arrow = '<i class="fas fa-arrow-down leftmargin"></i>';
        } else {
            order_by = 'desc'
            arrow = '<i class="fas fa-arrow-up leftmargin"></i>';
        }

        //Here to remove arrow from previous
        var prev_column = this.state.order_column;
        var prev_dynamic_id = 'col_' + prev_column;

        if (document.getElementById(prev_dynamic_id))
            document.getElementById(prev_dynamic_id).innerHTML = document.getElementById(prev_dynamic_id).textContent;
        //End

        localStorage.setItem('order_by', order_by);
        localStorage.setItem('order_column', column);
        this.setState({ order_by: order_by, order_column: column }, function () {
            var cur_header_text = document.getElementById(dynaic_id).textContent;
            var final_hdr_cntd = cur_header_text + arrow;
            document.getElementById(dynaic_id).innerHTML = final_hdr_cntd;

            this.leaveRewardBalance();
        });
    }
    LeaveApplications(page = 1) {
        window.$(document).ready(function () {
            window.$('.loader-new').removeClass('hidden');
            window.$('.Apps').addClass('hidden');
        });
        fetch(this.state.apiUrl + '/HrmanagementRest/leaveRewardBalance/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                window.$(document).ready(function () {
                    window.$('.loader-new').addClass('hidden');
                    window.$('.Apps').removeClass('hidden');
                });

                this.setState({
                    total_er: findresponse.total_er,
                    config: findresponse.config,
                    owners: findresponse.owners,
                    saved_filters: findresponse.saved_filters,
                    supportLevels: findresponse.supportLevels,
                    item_count: findresponse.item_count,
                    team: findresponse.team,
                    product_line: findresponse.product_line,
                    category: findresponse.category,
                    type: findresponse.type,
                    priority: findresponse.priority,
                    server: findresponse.server,
                    status: findresponse.status,
                    effort: findresponse.add_sub_effort,
                    microservice: findresponse.microservice,
                    isLoadMore: 1,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })
            })
    }
    //ER#63778 Leave application end

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Leave & Rewards" brecum_page="Leave & Rewards" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <span>Leave & Rewards</span>
                        </div>
                        <div class="top-row">
                            <div class="main_dashborad l_r">
                                <div class="pro_image pimage">
                                    {this.state.attachment && this.state.attachment_url ? <img src={this.state.attachment_url + this.state.attachment} /> : <span class="profile_first_name">{this.state.emp_start_name}</span>}
                                </div>
                                <div class="emp_det">
                                    <h6>
                                        <Link to={`/viewEmployee/${this.props.match.params.employeeId}`} name={"max"}>
                                            {this.state.name ? this.state.name : '--'}
                                        </Link>
                                    </h6>
                                    <h5>
                                        {this.state.position ? this.state.position : '--'}
                                    </h5>
                                </div>
                                {/* {this.state.leavesAvailable <= 0 ? <h6>
                                    <button type="button" class="btn btn-sky mob-dash" data-toggle="modal" data-target="#FailedLeave" data-dismiss="modal">Apply Leave</button>
                                </h6> : <h6>
                                        <button type="button" onClick={() => this.employee_details(this.state.userId)} class="btn btn-sky mob-dash" data-toggle="modal" data-target="#Modalreminder" data-dismiss="modal">Apply Leave</button>
                                    </h6>} */}

                                {this.state.leave_reward_state == 1
                                    ?
                                    <div class="dash lreward">
                                        <div class="add_dash"><div class="dash_price Greeen">{this.state.leavesAvailable ? this.state.leavesAvailable : 0}</div><div class="dash_wb">{this.state.leavesAvailable <= 1 ? 'Leave Available' : 'Leaves Available'} {`(Q${this.state.current_quarter || ""})`}</div></div>
                                        <div class="add_dash"><div class="dash_price Red">{this.state.leavestaken}</div><div class="dash_wb">{this.state.leavestaken <= 1 ? 'Leave Taken' : 'Leaves Taken'}</div></div>
                                        <div class="add_dash"><div class="dash_price Red">{this.state.advance_leave_cnt ? this.state.advance_leave_cnt : 0} / {this.state.lop_cnt ? this.state.lop_cnt : 0}</div><div class="dash_wb">Advance / LOP</div></div>
                                        <div class="add_dash"><div class="dash_price Red">{this.state.leave_earned ? this.state.leave_earned : 0} / {this.state.carry_forward_leave_earned ? this.state.carry_forward_leave_earned : 0}</div><div class="dash_wb">Allocated Leaves / Carry Forward</div></div>
                                    </div>
                                    :
                                    this.state.leave_reward_state == 2 ? <div class="dash">
                                        {/* <div class="add_dash"><div class="dash_price Greeen"></div><div class="dash_wb"></div></div> */}
                                    </div> :
                                        <div class="dash">
                                            <div class="add_dash reward"><div class="dash_price">{this.state.rewardsPoints ? this.state.rewardsPoints : 0}</div><div class="dash_wb">{this.state.rewardsPoints <= 1 ? 'Reward Points' : 'Rewards Points'}</div></div>
                                        </div>
                                }
                            </div>
                            <div id="exTab1" class="container">
                                <div class="row" style={{ alignItems: 'center' }}>
                                    <div class="col-md-6 col-xs-12">
                                        <ul class="nav nav-pills leave-pills">
                                            <li class="active"><a class="tab" onClick={() => this.changeStateRewardLeave()} href="#Login" data-toggle="tab">My Leaves</a>
                                            </li>
                                            <li><a class="tab" onClick={() => this.changeStateLeaveReward()} href="#Upload" data-toggle="tab">My Rewards</a>
                                            </li>
                                            {this.state.view_access == 1 ? <li><a onClick={() => this.changeStateLeaveApp()} href="#Apps" data-toggle="tab" class="leave-app-tab tab" >My Team's Leaves</a>
                                            </li> : ''}
                                        </ul>
                                    </div>

                                    <div class="col-md-6 col-xs-12">
                                        <div class="searchTicket emp_dept leave-search" id="leave-search" style={{ display: 'none' }}>
                                            <input type="text" class="form-control" name="search" id="search" style={{ fontSize: '14px', padding: '8px' }} placeholder="Search By Employee Name" onChange={this.searchChange} /><button type="submit"><i class="fa fa-search"></i></button>
                                        </div>
                                        <div class="searchTicket filter dept hidden-md"><i class="fa fa-sliders hidden-md filter"></i></div>
                                    </div>

                                </div>
                                {/*  */}

                                <div class="tab-content customer-tab clearfix">
                                    <div class="tab-pane active" id="Login">
                                        <ul class="tickets_head">
                                            <li class="intra_col_25"><p><span>Leave Duration</span></p></li>
                                            <li class="intra_col_25">Reason</li>
                                            <li class="intra_col_10">Day(S)</li>
                                            <li class="intra_col_20">Type</li>
                                            <li class="intra_col_15">Status</li>
                                        </ul>
                                        {this.state.leaves.length == 0 ? <div className="text-center" style={{ color: 'red' }}>No Data Found</div> :
                                            this.state.leaves.map((user, key) =>
                                                <ul class="tickets_number">
                                                    <li class="intra_col_25">{user.date + ' - ' + user.to_date}</li>
                                                    <li class="intra_col_25">{user.note ? <p><div dangerouslySetInnerHTML={{ __html: user.note }} /></p> : '--'}</li>
                                                    <li class="intra_col_10">{user.days}</li>
                                                    <li class="intra_col_20">{user.leave_category}</li>
                                                    <li class="intra_col_15"> {user.status == 'pending' ? <span class="error">Pending</span> : user.status == 'approved' ? <span class="green">Approved</span> : <span class="error">Declined</span>}</li>
                                                </ul>

                                            )
                                        }
                                    </div>
                                    <div class="tab-pane" id="Upload">
                                        <ul class="tickets_head" >
                                            <li class="intra_col_20">Date</li>
                                            <li class="intra_col_20">Rewards</li>
                                            <li class="intra_col_40">Reason</li>
                                        </ul>
                                        {
                                            this.state.rewards.length == 0 ? <div className="text-center" style={{ color: 'red' }}>No Data Found</div> : this.state.rewards.map((user, key) =>
                                                <ul class="tickets_number">
                                                    <li class="intra_col_20">{user.date}</li>
                                                    <li class={'intra_col_20 ' + (user.is_credited == 2 ? 'text-danger' : 'text-success')}>{user.is_credited == 2 ? <i class='fa fa-minus fa-thin text-danger'></i> : <i class='fa fa-plus fa-thin text-success'></i>} {user.credit_reward}</li>
                                                    <li class="intra_col_40">{user.note ? <p><div dangerouslySetInnerHTML={{ __html: user.note }} /></p> : '--'}</li>
                                                </ul>
                                            )

                                        }
                                    </div>
                                    <div class="tab-pane" id="Apps">
                                        <div class="row" >

                                        </div>
                                        <div class="row" style={{ marginLeft: '5px' }}>
                                            <ul class="tickets_head">
                                                <li class="intra_col_20" id="col_name" onClick={this.SortCloumn.bind(this, 'name')}>Name <i class="fa fa-sort"></i></li>
                                                <li class="intra_col_20" id="col_leave_duration" onClick={this.SortCloumn.bind(this, 'leave_duration')}>Leave Duration <i class="fa fa-sort"></i></li>
                                                <li class="intra_col_20" id="col_reason" >Reason</li>
                                                <li class="intra_col_7">Day(S)</li>
                                                <li class="intra_col_15" id="col_available_leave" >Leave Available </li>
                                                <li class="intra_col_10" id="col_available_leave" >Type</li>
                                                <li class="intra_col_8" id="col_status" onClick={this.SortCloumn.bind(this, 'status')}>Status <i class="fa fa-sort"></i></li>
                                            </ul>
                                            {
                                                this.state.manager_of_user.length == 0 ? <div className="text-center" style={{ color: 'red' }}>No Data Found</div> :
                                                    this.state.manager_of_user.map((user, key) =>
                                                        <ul class="tickets_number">
                                                            <li class="intra_col_20">{<Link to={`/viewEmployee/${user.employee_id}`} name={"max"}>{user.name}</Link>}</li>
                                                            <li class="intra_col_20">{user.date + ' - ' + user.to_date}</li>
                                                            <li class="intra_col_20">{user.note ? <p><div dangerouslySetInnerHTML={{ __html: user.note }} /></p> : '--'}</li>
                                                            <li class="intra_col_7">{user.days}</li>
                                                            <li class="intra_col_15">{user.available_leave}</li>
                                                            <li class="intra_col_10">{user.leave_category}</li>
                                                            {user.status == 'pending' ? <li class="intra_col_8">
                                                                <span class="error">Pending</span>
                                                                {/* <div class="leave_reward_app">
                                                                    <span class="app" onClick={() => this.leave_detail(user.id)} data-toggle="modal" data-target="#approveLeave"><i class="fal fa-check-circle"></i></span>
                                                                    <span class="dec" onClick={() => this.leave_detail(user.id)} data-toggle="modal" data-target="#declineLeave"><i class="fal fa-times-circle"></i></span>
                                                                </div> */}
                                                            </li> : user.status == 'approved' ? <li class="intra_col_8"><span class="green">Approved</span></li> : <li class="intra_col_8"><span class="error">Declined</span></li>}


                                                        </ul>

                                                    )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <--modal start for applying leave-!> */}
                            <div class="modal fade" id="Modalreminder" role="dialog">
                                <div class="modal-dialog modal-md">
                                    <div class="modal-content">

                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                            <h4 class="modal-title">Apply Leave</h4>
                                        </div>
                                        <div class="modal-body">
                                            <div class="form-group">
                                                <input type="hidden" class="form-control" name="emp_id" value={this.state.employee.id} />
                                                Employee Name
                                                <input type="text" class="form-control" name="emp_name" placeholder="Employee Name" value={this.state.employee.name} disabled onChange={this.onChange} />
                                            </div>
                                            <div class="form-group">
                                                Employee ID
                                                <input type="text" class="form-control" name="emp_muvi_id" placeholder="Employee Id" value={this.state.employee.muvi_employee_id} disabled onChange={this.onChange} />
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        From Date
                                                        <DatePicker
                                                            selected={this.state.startDate}
                                                            selectsStart
                                                            startDate={this.state.startDate}
                                                            endDate={this.state.endDate}
                                                            onChange={this.handleChangeStart}
                                                            minDate={new Date()}
                                                            dateFormat="dd/MM/yyyy"
                                                            readOnly={true}
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                        />
                                                        <p class="feature-check mar_top_20 margin_bottom_less">
                                                            <input type="checkbox" id="half_day_first" name="half_day_first" class="half_day_first" value onChange={this.onHalfDayFirstChange} />
                                                            <label for="half_day_first"><span></span>Half Day</label>
                                                        </p>
                                                    </div>
                                                    <div class="col-md-6">
                                                        To Date
                                                        <DatePicker
                                                            selected={this.state.endDate}
                                                            selectsEnd
                                                            startDate={this.state.startDate}
                                                            endDate={this.state.endDate}
                                                            onChange={this.handleChangeEnd}
                                                            minDate={new Date()}
                                                            dateFormat="dd/MM/yyyy"
                                                            readOnly={true}
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                        />
                                                        {this.getRangeCheck()}

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="modal-box">
                                                <div class="add_dash"><div class="dash_price Greeen">{this.state.leavesAvailable}</div><div class="dash_wb">{this.state.leavesAvailable <= 1 ? 'Leave Balance' : 'Leaves Balance'}</div></div>
                                                <div class="add_dash pull-right"><div class="dash_price Red">{this.state.leavestaken}</div><div class="dash_wb">{this.state.leavestaken <= 1 ? 'Leave Taken' : 'Leaves Taken'}</div></div>
                                            </div>
                                            <br></br>
                                            Reason for Leave
                                            <textarea type="text" name="leave_note" class="form-control" onChange={this.onChange}></textarea>
                                            <span class="error">{this.state.registered_mail}</span>
                                            <br></br>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-sky" onClick={() => this.apply_leave()} >Apply</button>
                                            <button type="button" class="btn btn-blue" data-dismiss="modal">No</button>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            {/* <--modal end for applying leave-!> */}

                            {/* <--modal start for failed leave-!> */}
                            <div class="modal fade" id="FailedLeave" role="dialog">
                                <div class="modal-dialog modal-md">
                                    <div class="modal-content">

                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                            <h4 class="modal-title"></h4>
                                        </div>
                                        <div class="modal-body">
                                            Sorry, You are out of Available Leaves. Please mail to your respective manager for applying Leave.
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-blue" data-dismiss="modal">Close</button>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            {/* <--modal end for failed leave-!> */}

                            {/* <--modal start for approving Leave-!> */}
                            <div class="modal fade" id="approveLeave" role="dialog">
                                <div class="modal-dialog modal-md">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                            <h4 style={{ color: "black" }} class="modal-title">Approve Leave</h4>
                                        </div>
                                        <div class="modal-body">
                                            Reasons :
                                            <textarea type="text" name="approve_note" class="form-control" onChange={this.onChange} ></textarea>
                                        </div>

                                        <div class="modal-footer">

                                            <button type="button" class="btn btn-sky" onClick={() => this.approve_leave(this.state.leave_detail.id)} >OK</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <--modal end for approving Leave-!> */}

                            {/* <--modal start for declining Leave-!> */}
                            <div class="modal fade" id="declineLeave" role="dialog">
                                <div class="modal-dialog modal-md">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                            <h4 style={{ color: "black" }} class="modal-title">Decline Leave</h4>
                                        </div>
                                        <div class="modal-body">
                                            Reasons :
                                            <textarea type="text" name="decline_note" class="form-control" onChange={this.onChange} ></textarea>
                                            <span class="error">{this.state.errors["decline_note"]}</span><br></br>
                                        </div>

                                        <div class="modal-footer">

                                            <button type="button" class="btn btn-sky" onClick={() => this.decline_leave(this.state.leave_detail.id)}>OK</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <--modal end for declining Leave-!> */}
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}
export default LeaveReward;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/leaveReward.js